
export interface ApiResp {
    code: number,
    data: any,
    msg: string
}

// api接口域名
// export const APIURL = 'http://192.168.31.226:81'
// export const APIURL = 'http://xyc.ai:81/'
export const APIURL = 'https://xyc.hk.cn/'
// export const APIURL = '/'


export const API_CODE_SUCCESS = 0
export const API_CODE_FAIL = 1
export const API_CODE_UNAUTH = 2
export const API_CODE_UNREFRESH = 3

export const USER_TOKEN = 'usertoken'   
export const USER_REF_TOKEN = 'userreftoken'

export type RequestParams = {
    method: string
    header?: Record<string, string>
    path?: string
    query?: Record<string, any>
    body?: any
    hideLoading?: boolean
    loadingTxt?: string
}

export type responseData = {
    code: number
    data: any
    msg: string
}


